import { InputSelectControlField } from '@sequencehq/core-components'
import { CountriesAlpha2 } from '@sequencehq/api/utils/commonEnums'
import { ValidationError } from '@sequencehq/utils'
import { FC } from 'react'
import { countriesOptions } from './countryOptions'

type CountrySelectFieldProps = {
  value?: CountriesAlpha2 | ''
  initialValue?: CountriesAlpha2 | ''
  onChange: (country: CountriesAlpha2) => void
  /** Pass to let the user clear a picked country with a ✕ in the select. */
  onClear?: () => void
  placeholder?: string
  validationErrors?: ValidationError[]
  label?: string
  styles?: Record<string, Record<string, unknown>>
  'data-testid'?: string
}

export const CountrySelectField: FC<CountrySelectFieldProps> = ({
  value,
  initialValue,
  onChange,
  onClear,
  placeholder = 'Select country',
  validationErrors,
  label,
  styles,
  'data-testid': dataTestId
}) => (
  <InputSelectControlField
    data-testid={dataTestId}
    label={label}
    {...(value !== undefined
      ? { value }
      : { initialValue: initialValue ?? '' })}
    onChange={newValue => onChange(newValue as CountriesAlpha2)}
    onClear={onClear}
    options={countriesOptions}
    placeholder={placeholder}
    validationErrors={validationErrors}
    styles={styles}
  />
)
